import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["item", "panel"];

  connect() {
    const activeTab = this.element.querySelector(".cult-tab.active");
    const initialGrade = activeTab ? activeTab.dataset.grade : null;

    this.itemTargets.forEach((item) => {
      const show = !initialGrade || item.dataset.grade === initialGrade;
      item.style.display = show ? "" : "none";
    });

    if (window.innerWidth <= 900) {
      this.itemTargets.forEach((i) => i.classList.remove("active"));
      this.panelTargets.forEach((p) => p.classList.remove("active"));
    } else {
      const firstVisible = this.itemTargets.find((i) => i.style.display !== "none");
      if (firstVisible) this._activateDesktop(firstVisible);
    }
  }

  filter(event) {
    const grade = event.currentTarget.dataset.grade;

    this.element.querySelectorAll(".cult-tab").forEach((tab) => {
      tab.classList.toggle("active", tab.dataset.grade === grade);
    });

    this.itemTargets.forEach((item) => {
      const show = item.dataset.grade === grade;
      item.style.display = show ? "" : "none";
    });

    const firstVisible = this.itemTargets.find((i) => i.style.display !== "none");
    if (firstVisible) this._activateDesktop(firstVisible);
  }

  select(event) {
    if (window.innerWidth <= 900) {
      this._activateMobile(event.currentTarget);
    } else {
      this._activateDesktop(event.currentTarget);
    }
  }

  _activateDesktop(item) {
    const variety = item.dataset.variety;
    this.itemTargets.forEach((i) => i.classList.remove("active"));
    item.classList.add("active");
    this.panelTargets.forEach((panel) => {
      panel.classList.toggle("active", panel.dataset.variety === variety);
    });
  }

  _activateMobile(item) {
    const variety = item.dataset.variety;
    const isAlreadyActive = item.classList.contains("active");

    this.itemTargets.forEach((i) => i.classList.remove("active"));
    this.panelTargets.forEach((p) => p.classList.remove("active"));

    if (isAlreadyActive) return;

    item.classList.add("active");

    const panel = this.panelTargets.find((p) => p.dataset.variety === variety);
    if (panel) {
      item.insertAdjacentElement("afterend", panel);
      panel.classList.add("active");
    }
  }
}
